/**
 * @module app.um
 */

import { autoinject, PLATFORM } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { openGlobalModal, IModalData, IDialogOptions } from 'app/shared/elements/ess-global-modal';
import { AuthService } from 'app/um/services/auth-service';
import { apiCall } from 'app/shared/lib/api/api';
import * as UM from 'app/um/models/essette-api';

export interface IAlternateAuthSummaryModelData {
    alternateAuthNumber: string;
    authId: string;
}

@autoinject()
export class AlternateAuthSummary extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    //private altSummary: UM.AlternateAuthSummary | null = null;
    protected services: UM.AuthService[] | null = null;
    protected summaryVersion: string | null | undefined = null;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: AuthService,
        //private readonly authContext: AuthPageContext,
        ...rest: any[]) {

        super(...rest);
    }

    protected async activate(model: IAlternateAuthSummaryModelData): Promise<void> {
        if(!model) return;

        this.loadAlternateAuthSummary(model.authId);
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadAlternateAuthSummary(authId: string): Promise<void> {
        if(!authId) return;

        try {
            const includes: string[] = ['alternateAuthSummary'];

            this.state.beginLoad();

            const response = await this.service.loadAlternateAuthSummary(authId, includes);
            if(!response.isSuccessful || response.results.length == 0) return;

            const auth: UM.Auth = response.results[0];
            const altSummary: UM.AlternateAuthSummary | null | undefined = auth.alternateAuthSummary;
            if(altSummary == null || altSummary == undefined) return;

            this.summaryVersion = altSummary.versionNumber;
            const obj = JSON.parse(altSummary?.summaryJson!);
            this.services = obj;
        }
        catch(error) {
            throw error;
        }
        finally {
            this.state.endLoad();
        }
    }

}

/**
 * Opens the alternate auth summary modal with the global dialog
 * @param alternateAuthNumber The alternateAuthNumber to use
 */
export function openAlternateAuthSummary(alternateAuthNumber: string, authId: string): void {
    if(!alternateAuthNumber) throw new Error('Alternate Auth Number is missing or invalid');

    const dialogOptions: IDialogOptions = {
        width: '10',
        height: '11',
        title: {
            key: 'um:auth.alternateAuthSummary',
            replace: { number: alternateAuthNumber }
        },
        print: false
    };

    const modelData: IAlternateAuthSummaryModelData = {
        alternateAuthNumber: alternateAuthNumber,
        authId: authId
    };

    const modalData: IModalData = {
        componentId: PLATFORM.moduleName('app/um/components/auth/alternate-auth-summary'),
        modelData: modelData,
        dialogOptions: dialogOptions
    };

    openGlobalModal(modalData);
}
